'use client';

import { useEffect, useRef, useState } from 'react';

// The design's FX reveal: flips once when the element enters the viewport
// (or already sits above it on load). Reduced motion is handled in CSS.
export const useRevealIn = <T extends Element>() => {
  const ref = useRef<T>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el || typeof IntersectionObserver === 'undefined') return;
    const io = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          setInView(true);
          io.disconnect();
        }
      },
      { rootMargin: '0px 0px -5% 0px', threshold: 0.06 },
    );
    io.observe(el);
    const timer = window.setTimeout(() => {
      if (el.getBoundingClientRect().top < window.innerHeight * 1.05) {
        setInView(true);
        io.disconnect();
      }
    }, 120);
    return () => {
      io.disconnect();
      window.clearTimeout(timer);
    };
  }, []);

  return [ref, inView] as const;
};
